module.exports = __webpack_public_path__ + "static/media/fuse-logo-horizontal-180.2bc77e73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/NavNoLogout/assets/fuse-logo-horizontal-180.svg
// module id = 1844
// module chunks = 193